import type { AddToBagButtonProps } from './addToBagButton';
import { AddToBagButton } from './addToBagButton';
import type { EditQuantityButtonProps } from './editQuantityButton';
import { EditQuantityButton } from './editQuantityButton';

export type CtaButtonProps = Omit<AddToBagButtonProps, 'isAddingToCart'> &
  Pick<
    EditQuantityButtonProps,
    'onIncrease' | 'onDecrease' | 'isUpdatingCart' | 'productName'
  >;

export function CtaButton({
  onIncrease,
  onDecrease,
  productName,
  ...addToBagProps
}: CtaButtonProps) {
  const {
    atMaxQuantity,
    cartCount = 0,
    cardSize,
    ctaStyle,
    hasMultipleWeights,
    isUpdatingCart,
    onSelectWeight,
  } = addToBagProps;

  return cartCount > 0 && ctaStyle !== 'card_bottom' ? (
    <EditQuantityButton
      atMaxQuantity={atMaxQuantity}
      cardSize={cardSize}
      cartCount={cartCount}
      ctaStyle={ctaStyle}
      hasMultipleWeights={hasMultipleWeights}
      isUpdatingCart={isUpdatingCart}
      onIncrease={onIncrease}
      onDecrease={onDecrease}
      onSelectWeight={onSelectWeight}
      productName={productName}
    />
  ) : (
    <AddToBagButton {...addToBagProps} isAddingToCart={isUpdatingCart} />
  );
}
